module.exports = "<div class=\"item-container\">\n    <article #itemInput class=\"item\" contenteditable (blur)=\"contentChanged(itemInput.innerText)\" (keydown)=\"onKeyDown($event)\">\n        <span *ngFor=\"let part of parts\" class=\"{{part.type}}\">{{ part.text }}</span>\n    </article>\n    <nav>\n        <a (click)=\"delete()\"><i class=\"fa fa-trash-o fa-lg\"></i></a>\n    </nav>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/items/Item.component.html
// module id = ../../../../../src/app/items/Item.component.html
// module chunks = main